import React from 'react';
import { AppProvider } from '../context/AppProvider';

export const RootElement = ({ children }) => {
    return <AppProvider>{children}</AppProvider>;
};

// module.exports = RootElement;
// export default RootElement;